import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { BrandLogoComponent } from '../brand-logo/brand-logo.component';

/**
 * AppSplash — the branded post-login interstitial shown while a portal's data
 * loads after sign-in. One full-screen splash for every portal: ocean welcome
 * gradient + the luminous dark lockup + a centered amber spinner. Replaces the
 * four different bare spinners and gives the auth handshake a real brand moment.
 */
@Component({
  selector: 'bodyanalytics-app-splash',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-splash.component.html',
  styleUrls: ['./app-splash.component.scss'],
  imports: [BrandLogoComponent],
})
export class AppSplashComponent {
  /** Live status line under the spinner. */
  status = input('Preparing your dashboard…');
  /** Optional decorative footer tagline (small mono caps). */
  footer = input('');
}
